/**
 * Vertical Thumbnail Gallery Navigation
 * Para el tema Dawn de Shopify
 * 
 * Este script maneja:
 * - Navegación con botones arriba/abajo
 * - Scroll suave de las miniaturas
 * - Estado de los botones (habilitado/deshabilitado)
 */

class VerticalThumbnailSlider {
  constructor() {
    this.init();
  }

  init() {
    // Buscar todos los sliders verticales
    this.sliders = document.querySelectorAll('.thumbnail-slider--vertical');
    
    if (this.sliders.length === 0) {
      // Si no hay sliders al cargar, intentar de nuevo después
      if (document.readyState !== 'complete') {
        window.addEventListener('load', () => this.init());
      }
      return;
    }

    this.sliders.forEach(slider => this.setupSlider(slider));
  }

  setupSlider(slider) {
    const list = slider.querySelector('.thumbnail-list--vertical');
    const prevBtn = slider.querySelector('.slider-button--prev');
    const nextBtn = slider.querySelector('.slider-button--next');

    if (!list) return;

    // Configuración
    const scrollAmount = 100; // Pixeles a scrollear por click

    // Función para actualizar estado de botones
    const updateButtons = () => {
      if (!prevBtn || !nextBtn) return;
      
      const isAtTop = list.scrollTop <= 5;
      const isAtBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 5;

      prevBtn.classList.toggle('hidden', isAtTop);
      nextBtn.classList.toggle('hidden', isAtBottom);
      
      prevBtn.disabled = isAtTop;
      nextBtn.disabled = isAtBottom;
    };

    // Event listeners para botones
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        list.scrollBy({
          top: -scrollAmount,
          behavior: 'smooth'
        });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        list.scrollBy({
          top: scrollAmount,
          behavior: 'smooth'
        });
      });
    }

    // Actualizar botones al hacer scroll
    list.addEventListener('scroll', updateButtons);

    // Actualizar estado inicial
    updateButtons();

    // Observar cambios en el contenido
    const observer = new MutationObserver(updateButtons);
    observer.observe(list, { childList: true, subtree: true });

    // Actualizar al redimensionar
    window.addEventListener('resize', updateButtons);
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new VerticalThumbnailSlider());
} else {
  new VerticalThumbnailSlider();
}

// También inicializar después de que Shopify cargue secciones dinámicamente
document.addEventListener('shopify:section:load', () => {
  setTimeout(() => new VerticalThumbnailSlider(), 100);
});
